<script>
  export let url=""
  export let toolbar=false
  export let columns = []
  export let data
  export let id = null
  export let rowheight = null
  export let multiselect
  export let selected = []
  import { createEventDispatcher } from 'svelte'
  import Grid from "./grid.svelte"
  import Search from "./search.svelte"
  import Button from "./button.svelte"
  import {load} from "./api.js"
  import Confirm from "./confirm.svelte"
  import AddIcon from "../icons/add.svelte"
  import TrashIcon from "../icons/trash.svelte"
  import EditIcon from "../icons/edit.svelte"

  const dispatch = createEventDispatcher();
  let filteredData = [];
  let confirmDelete = false;
  const SLOTS = $$props.$$slots // HACK!! until https://github.com/sveltejs/svelte/issues/2106 is resolved
  
  // override for custom filter
  export let filter = (row)=> {
    return true
  }

  // if no data is supplied and a url is, loaded data from local store
  if(url && !data){
    let loader = load(url)
    data = []
    ;(async ()=> data = (await loader).data )()
  }

  $: griddata = data ? ( toolbar ? filteredData.filter(filter) : data.filter(filter) ) : []

</script>

<div class="crudlist">
  {#if toolbar}
    <div class="toolbar">
      <div class="btn-group">
        <Button  on:click={(e)=> dispatch('add')} ><AddIcon color="#444" /></Button>
        <Button  disabled={!id} on:click={(e)=> dispatch('edit',[{id}])}><EditIcon color="#444" /></Button>
        <Confirm on:confirm={dispatch('delete',[{id}])} mode="default" placement="bottom">
          <TrashIcon color="#444" />
        </Confirm>
        <slot name="tools" selectedid={id}> </slot>
      </div>
      <div class="search">
        <Search placeholder="Search" bind:filtered={filteredData} bind:data={data}></Search>
      </div>
    </div>
  {/if}

  <div class="gridarea">
    <!-- Horrible hack below because we can't wrap slot= in an if -->
    {#if SLOTS && SLOTS.row && SLOTS.footer}
      <Grid data={griddata} {multiselect} bind:selected={selected} rowheight={rowheight} columns={columns} on:click={(e)=> id = e.detail.length ? e.detail[0].id : null} on:dblclick={(e)=> dispatch('edit',e.detail)} >
        <div slot="row" let:item><slot name="row" {item}></slot></div>
        <div slot="footer" let:data><slot name="footer" {data}></slot></div>
      </Grid>
    {:else if SLOTS && SLOTS.row}
      <Grid data={griddata} {multiselect} bind:selected={selected} rowheight={rowheight} columns={columns} on:click={(e)=> id = e.detail.length ? e.detail[0].id : null} on:dblclick={(e)=> dispatch('edit',e.detail)} >
        <div slot="row" let:item><slot name="row" {item}></slot></div>
      </Grid>
    {:else if SLOTS && SLOTS.footer}
      <Grid data={griddata} {multiselect} bind:selected={selected} rowheight={rowheight} columns={columns} on:click={(e)=> id = e.detail.length ? e.detail[0].id : null} on:dblclick={(e)=> dispatch('edit',e.detail)} >
        <div slot="footer" let:data><slot name="footer" {data}></slot></div>
      </Grid>
    {:else}
      <Grid data={griddata} {multiselect} bind:selected={selected} rowheight={rowheight} columns={columns} on:click={(e)=> id = e.detail.length ? e.detail[0].id : null} on:dblclick={(e)=> dispatch('edit',e.detail)} ></Grid>
    {/if}
  </div>
</div>

<style>
  .btn-group{
    padding:5px 0;
    --s-button-margins:0px;
  }
  .toolbar{
    padding:0px 5px 0px 5px;
    display:flex;
    justify-content: space-between;
  }
  .btn-group > *{
    margin:0;
  }
  .crudlist{
    display:flex;
    flex-direction: column;
    height:100%;
    min-height:200px;/* prevent grid locking with 0 height */
  }
  .gridarea{
    flex: 1;
    overflow: auto;
  }
</style>